<div class="container-fluid out">
    <h2>Formations</h2>

    <!-- School 1 -->
    <div class="row py-lg-2">
        <div class="col-sm-2 offset-sm-2 left-educ info-left-animate">
            <p class="date">2021-2023</p>
            <p class="diploma-left">CDA </p>
            <div class="row logo-container">
                <div class="col-1">
                    <img class="logo-school" src="assets/2ii.png" />
                </div>
            </div>
        </div>
        <div class="col-sm-6 info-right-animate">
            <p class="diploma-right">Concepteur développeur d'application reconnu bac+4</p>
            <p class="school">2itech Academy à Villeneuve d'Ascq</p>
            <ul class="infos">
                <li> Maquetter une application </li>
                <li>Développer une interface utilisateur de type desktop </li>
                <li>Développer des composants d’accès aux données </li>
                <li>Développer la partie front-end d’une interface utilisateur Web </li>
                <li>Développer la partie back-end d’une interface utilisateur Web </li>
            </ul>
        </div>
    </div>

    <!-- Erasmus -->
    <div class="row py-lg-2">
        <div class="col-sm-2 offset-sm-2 left-educ info-left-animate">
            <p class="date">2018-2021</p>
            <p class="diploma-left">BTS SIO Option SLAM </p>
            <div class="row logo-container">
                <div class="col-1">
                    <img class="logo-school" src="assets/damp.jfif" />
                </div>
            </div>
        </div>
        <div class="col-sm-6 info-right-animate">
            <p class="diploma-right">BTS Services informatiques aux organisations</p>
            <p class="school">Lycée Dampierre,59300, Valenciennes </p>
            <ul class="infos">
                <li>
                    Spécialité développement avec des langages tels que Java , PHP, Framework Symfony, Html/Css,
                </li>

            </ul>
        </div>
    </div>

    <!-- School 2 -->
    <div class="row py-lg-4">
        <div class="col-sm-2 offset-sm-2 left-educ info-left-animate">
            <p class="date">2017-2018</p>
            <p class="diploma-left">Baccalauréat</p>
            <img class="logo-school" src="assets/paul.jpg" />
        </div>

        <div class="col-sm-6 info-right-animate">
            <p class="diploma-right">Baccalauréat SI, spécialité ISN</p>
            <p class="school">Lycée Paul Duez, 59400, Cambrai</p>
            <ul class="infos">
                <li>
                    Projet en terminale sur une étude d'un vélo à assistance éléctrique (notion de mécanique) lié à la matière science de l'ingénieur
                </li>

            </ul>
        </div>
    </div>

    <!-- School 2 -->
    <div class="row py-lg-4">
        <div class="col-sm-2 offset-sm-2 left-educ info-left-animate">
            <p class="date">2017-2019</p>
            <p class="diploma-left">BAFA</p>
            <img class="logo-school" src="assets/insa_logo.png" />

        </div>
        <div class="col-sm-6 info-right-animate">
            <p class="diploma-right">Brevet d’aptitudes aux fonctions d’animateur </p>
            <p class="school">Université de Valenciennes ,59300</p>
            <ul class="infos">
                <li>
                    Approfondissement jeux sportifs
                </li>

            </ul>
        </div>
    </div>


</div>